(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["im-contact"] && !Shopify.designMode) return;
  try {
    

  jQuery( document ).ready(function() {
    
    KlaviyoSubscribe.attachToForms('#contact_form_klaviyo', {
        hide_form_on_success: true,
        extra_properties: {
          $source: '$contact_embed'
        }
    });

    jQuery("#contact_form").submit(function(event) {
        event.preventDefault()
        jQuery('button.contact-btn.klaviyo_submit_button').trigger('click')
    });

    jQuery('input[name="contact[first_name]"]').on('change', function (e) {
        jQuery('#k_id__firstname').val(jQuery(this).val())
    })

    jQuery('input[name="contact[last_name]"]').on('change', function (e) {
        jQuery('#k_id_lastname').val(jQuery(this).val())
    })
    
    jQuery('input[name="contact[email]"]').on('change', function (e) {
        jQuery('#k_id_email').val(jQuery(this).val())
    })
    
    jQuery('input[name="contact[phone]"]').on('change', function (e) {
        jQuery('#k_id_phonenumber').val(jQuery(this).val())
    })
    
    jQuery('textarea[name="contact[body]"]').on('change', function (e) {
        jQuery('#k_id_message').val(jQuery(this).val())
    })

    setTimeout(() => {
        if(jQuery('.shopify-section--contact-us .successful-message').is(':visible')){
           window.location.href = "/pages/contact"; 
        }
    }, "3000");
    
  });

  } catch(e) { console.error(e); }
})();
})();
